module.exports = __webpack_public_path__ + "img/index3.a1700f0c.png";